"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./TextArea.module.css"));
var TextArea = (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.enterKeyEvent = _this.enterKeyEvent.bind(_this);
        _this.changeFocus = _this.changeFocus.bind(_this);
        return _this;
    }
    TextArea.prototype.changeFocus = function (nextInputId) {
        var nextInputRef = document.getElementById(nextInputId);
        if (nextInputRef) {
            nextInputRef.focus();
        }
    };
    TextArea.prototype.enterKeyEvent = function (event) {
        if (event.key == "Enter" && this.props.nextInputId) {
            this.changeFocus(this.props.nextInputId);
        }
    };
    TextArea.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, rows = _a.rows, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, classNameWrap = _a.classNameWrap, className = _a.className;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
        }
        css = css + " " + className;
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("textarea", { rows: rows, className: css, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, placeholder: placeholder, disabled: disabled, onKeyDown: this.enterKeyEvent }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    TextArea.defaultProps = {
        rows: 5,
        errors: {}
    };
    return TextArea;
}(react_1.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=data:application/json;base64,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